import { Audience, createProgramContext } from '@plentifulapp/plentiful-program-configuration';
import { EnvVars } from '../../constants/EnvConfig';

/**
 * The audience this app serves
 * ---
 *
 * Bound into {@link neighborProgramContext} and reused for per-version step
 * projection (`selectStepsForAudience`) so the two can never disagree on which
 * audience the Neighbors app represents.
 */
export const NEIGHBOR_AUDIENCE: Audience = 'neighbor';

/**
 * The Neighbors app's single bound program context
 * ---
 *
 * `plentiful-program-configuration` binds a consumer's fixed identity once —
 * its audience and the environment labels it grants — rather than threading them
 * through every call. This app is one such consumer: the neighbor audience, in
 * the single environment resolved by {@link EnvVars}. Granting that environment's
 * label honours each program's `publishFor` gate, so a program published only for
 * development/staging stays hidden in production yet visible where it is meant to
 * be tested.
 */
export const neighborProgramContext = createProgramContext({
  audience: NEIGHBOR_AUDIENCE,
  declaredLabels: [EnvVars.environment],
});
